import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@env';

@Injectable({ providedIn: 'root' })
export class TelemetryService {
  private appInsights: ApplicationInsights | null = null;

  init(): void {
    const connString = environment.appInsights.connectionString;
    if (!connString) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: connString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
      },
    });
    this.appInsights.loadAppInsights();
  }

  trackPageView(name: string, uri?: string): void {
    this.appInsights?.trackPageView({ name, uri });
  }

  trackEvent(name: string, properties?: Record<string, string>): void {
    this.appInsights?.trackEvent({ name }, properties);
  }

  trackException(error: unknown, properties?: Record<string, string>): void {
    const exception = error instanceof Error ? error : new Error(String(error));
    this.appInsights?.trackException({ exception }, properties);
  }

  trackMetric(name: string, average: number, properties?: Record<string, string>): void {
    this.appInsights?.trackMetric({ name, average }, properties);
  }

  setAuthenticatedUser(userId: string): void {
    this.appInsights?.setAuthenticatedUserContext(userId);
  }

  clearAuthenticatedUser(): void {
    this.appInsights?.clearAuthenticatedUserContext();
  }
}
